// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html{font-size:16px !important}.PaperSelector-cls1__eed4c0fbe26f76500553{/*!*/}.PaperSelector-cls2___1e12db6e820cf142a44{font-family:\"Georgia\",\"Times New Roman\",serif;font-family:var(--type-font-family-serif, \"Georgia\"),\"Times New Roman\",serif;font-style:normal;font-weight:400;font-size:16px;line-height:20px;color:#223}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperSelector-cls1__eed4c0fbe26f76500553",
	"cls2": "PaperSelector-cls2___1e12db6e820cf142a44 PaperSelector-cls1__eed4c0fbe26f76500553"
};
export default ___CSS_LOADER_EXPORT___;
